import React from 'react';
import { connect } from 'react-redux';
import PianoChartContainer from 'components/pages/stats/dailyoccupancy/pianochartcontainer';
import { getStatsDaily, getParams } from 'actions/stats';
export class DailyOccupancy extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentNode.id) {
            let params = getParams(nextProps);
            this.props.dispatch(getStatsDaily(params));
        }
    }
    render() {
        let show = (this.props.querySettings.startdate == this.props.querySettings.enddate);
        var showPeak = true;
        if ((this.props.querySettings.tag == "Efficiency" && this.props.currentNode.type != "meeting_room") ||
            (this.props.querySettings.tag == "Occupancy" && this.props.currentNode.type == "meeting_room")) {
            showPeak = false;
        }
        return (
            <React.Fragment>
                {show || <PianoChartContainer tag={this.props.querySettings.tag} showPeak={showPeak} />}
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(null, mapDispatchToProps)(DailyOccupancy);


// WEBPACK FOOTER //
// ./src/components/pages/stats/dailyoccupancy/index.jsx